import { Component, OnInit, ViewEncapsulation, input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { IBreadCrumb } from '../../models/breadcrumb.model';


@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: [
        // '../../../../../assets/css/_background-variant.scss',
        // '../../../../../assets/css/_navbar.scss',
        // '../../../../../assets/css/_reboot.scss',
        // '../../../../../assets/css/odx-styles.css',
        // '../../../../../assets/css/overrides.css',
        // '../../../../../assets/css/ds-core.css',
        // '../../../../../assets/css/ds-button.css',
        // '../../../../../assets/css/ds-card.css',
        // '../../../../../assets/css/ds-form.css',
        // '../../../../../assets/css/ds-modal.css',
        // '../../../../../assets/css/ds-step-indicator.css',
        // '../../../../../assets/css/ds-tabs.css',
        // '../../../../../assets/css/ds-tile.css',
        './breadcrumb.component.css'
    ],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [RouterLink]
})
export class BreadcrumbComponent implements OnInit {
  readonly breadcrumbs = input<any[]>(undefined);

  constructor() {}

  ngOnInit(): void {}
}
